import { type AxiosResponse } from 'axios';
import { get, post, postWithoutToken, put } from '@utilities';

export const uploadFloorPlan = async (data: Record<string, any>): Promise<AxiosResponse> => await post('project/floor_plan', data);
export const sendOTP = async (data: Record<string, any>): Promise<AxiosResponse> =>
	await postWithoutToken('auth/lead/send_otp', data, { addSourceHeader: true });
export const verifyOTP = async (data: Record<string, any>): Promise<AxiosResponse> =>
	await postWithoutToken('auth/login/verify_otp', data, { addSourceHeader: true });
export const fetchQuotations = async (data): Promise<AxiosResponse> => await post(`quotation/all`, data);
export const addQuotation = async (data: Record<string, any>): Promise<AxiosResponse> => await post('quotation', data);
export const fetchUserDetails = async (): Promise<AxiosResponse> => await get('user');
export const updateQuotation = async (data): Promise<AxiosResponse> => await post(`quotation`, data);
export const getPredictionId = async (data: Record<string, any>): Promise<AxiosResponse> => await post('quotation/prediction', data);
// export const getPrediction = async (predictionId: string): Promise<AxiosResponse> =>
// 	await get(`quotation/prediction/${predictionId}`);
export const getPrediction = async (predictionId: string): Promise<AxiosResponse> =>
	await get(`quotation/prediction/${predictionId}/status`);
export const getPreDesignQuotation = async (data: Record<string, any>): Promise<AxiosResponse> =>
	await post('/pre-design/quotation', data);
export const getDefaultQuotations = async (data: Record<string, any>): Promise<AxiosResponse> =>
	await post('/pre-design/quotation/default', data);
export const fetchDocuments = async (docIds: any): Promise<AxiosResponse> => await post(`document/all`, docIds);
export const fetchQuotationById = async (QuotationId): Promise<AxiosResponse> => await get(`quotation/${QuotationId}`);
export const floorPlanValidator = async (data: Record<string, any>): Promise<AxiosResponse> => await post(`chat-gpt`, data);
export const uploadProjectDetails = async (data: Record<string, any>): Promise<AxiosResponse> => await put(`project/floor_plan`, data);
export const fetchProductCategories = async (data: Record<string, any>): Promise<AxiosResponse> => await post(`pre-design/categories`, data);
export const createQuotation = async (data): Promise<AxiosResponse> => await post(`quotation`, data);
export const fetchTicketChat = async (ticketId: any): Promise<AxiosResponse> => await get(`ticket/${ticketId}/chat`);
export const sendMessage = async (ticketId: any, data): Promise<AxiosResponse> =>
	await put(`ticket/${ticketId}/chat`, data);
export const closeTicket = async (ticketId: any): Promise<AxiosResponse> => await put(`ticket/${ticketId}`);
export const fetch2DJson = async (predictionId: any, currentFloor): Promise<AxiosResponse> =>
	await get(`mapping/${predictionId}/2-d?floor=${currentFloor}`);
export const fetch3DJson = async (predictionId: string, currentFloor: number): Promise<AxiosResponse> =>
	await get(`mapping/${predictionId}/3-d?floor=${currentFloor}`);
export const fetchSavedQuotation = async (predictionId): Promise<AxiosResponse> =>
	await get(`mapping/analysis/${predictionId}`);
export const getCutlistData = async (quotationID: any): Promise<AxiosResponse> =>
	await get(`quotation/${quotationID}/cutlist/all`);
export const getOptimiserData = async (cutlistData: any, projectId: any): Promise<AxiosResponse> =>
	await post(`quotation/cutlist/${projectId}/optimize`, { cutlist: cutlistData });
export const getOptimizedCutlistData = async (projectId: string): Promise<AxiosResponse> => {
	if (!projectId || String(projectId).toLowerCase() === 'undefined' || String(projectId).toLowerCase() === 'null') {
		throw new Error('Project id is required to fetch optimized cutlist');
	}
	return await get(`quotation/cutlist/${projectId}/optimized`);
};

export const fetchQuotationRemarkCount = async (quotationId: string): Promise<AxiosResponse> =>
	await get(`quotation/${quotationId}/remark/count`);
